import { camelCaseObject } from "@/helpers/object-mapper";

export class CompanyMember {
  constructor(apiData) {
    this.id = apiData.user.id;
    this.isActive = apiData.user.is_active;
    this.email = apiData.user.email;
    this.type = apiData.type;
    this.allFacilitiesAccess = apiData.all_facilities_access;
    this.invitationAccepted = apiData.invitation_accepted;
    this.facilitiesAccessCount = apiData.facilities_access_count;
    this.facilitiesGroupsAccessCount = apiData.facilities_groups_access_count;
    this.permissions = camelCaseObject(apiData.permissions);
    this.facilitiesIds = apiData.facilities_ids || [];
    this.facilitiesGroupsIds = apiData.facilities_groups_ids || [];
    this.permissionsObjectsType = apiData.permissions_objects_type;
  }
}
